var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var slugify = require('../utils/slugify.js');

function Metrics(el) {
  var $el = $(el),
      $list = $el.find('#metrics'),
      $issue = window.location.pathname.split('/')[2],
      $component = window.location.pathname.split('/')[3],
      $metricsData = '/wp-content/themes/justcapital/assets/data/methodology_metadata.json',
      $metrics,
      $data_source_names = {
        "brightscope":"Brightscope", 
        "co_filings":"Company filings and other public documents", 
        "co_filings_rdr":"Company filings and other public documents. The methodology was inspired by Ranking Digital Rights (https://rankingdigitalrights.org/). We collaborated on adapting their methodology to the needs of JUST Capital's rankings.", 
        "co_websites_covid":"Company websites, company press-releases, company newsroom page, reputable news sources", 
        "cpsc_fda_reprisk":"Consumer Product Safety Commission, Food and Drug Administration, and RepRisk for auto recalls", 
        "crowdsourced":"Crowdsourced company review platforms",  
        "crowdsourced_bls_mit":"Crowdsourced company review platforms, Bureau of Labor Statistics, MIT Living Wage Calculator, and third-party data",  
        "crowdsourced_bls":"Crowdsourced company review platforms and Bureau of Labor Statistics", 
        "customerguru":"Customer Guru",  
        "yougov":"YouGov", 
        "good_jobs_first":"Good Jobs First", 
        "iss":"Institutional Shareholder Services",  
        "jc":"JUST Capital", 
        "reprisk":"RepRisk",
        "standard_and_poors":"S&P/CapIQ",
      };

  $.getJSON($metricsData, function(data) {
    data.forEach(function(issue) {
      if ($issue === slugify(issue.name)) {
        issue.components.forEach(function(component) {
          if ($component === slugify(component.shortname)) {
            component.metrics.forEach(function(metric) {
              var $metricName = '<p class="metrics__name">' + metric.name + '</p>',
                  $metricData = '';
              metric.data.forEach(function(data) {
                $metricData += '<li><p class="metrics__data-name">' + data.name + '</p><p class="metrics__data-summary">' + data.summary + '</p><p class="metrics__data-source"><strong>Source:</strong> ' + ((typeof $data_source_names[data.source] != "undefined")?$data_source_names[data.source]:data.source) + '</p><p class="metrics__data-date"><strong>Date:</strong> ' + data.date + '</p></li>';
              });
              $list.append('<li>' + $metricName + '<ul class="metrics__data">' + $metricData + '</ul>' + '</li>');
            });
          }
        });
      }
    });
  });

}

module.exports = Metrics;
